// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2mx4j","topBottomGutter":"Layout_topBottomGutter__o8nu1"};